import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";
import variables from "../variables";

const {hasClass, getAll, removeClass, get, addClass} = $dom

const fullDescriptionGroupSelector = '.js-full-description-group'
const fullDescriptionButtonOpenSelector = '.js-full-description-button-open'
const fullDescriptionButtonCloseSelector = '.js-full-description-button-close'
const fullDescriptionHiddenTextSelector = '.js-full-description-hidden-text'

export default function () {
    const handleClick = (e) => {
        addClass(e.target, variables.classNames.hidden)
        addClass(get(fullDescriptionButtonCloseSelector, get(e.target.closest(fullDescriptionGroupSelector))), variables.classNames.visible)
        addClass(get(fullDescriptionHiddenTextSelector, get(e.target.closest(fullDescriptionGroupSelector))), variables.classNames.visible)
    }

    const handleClickClose = (e) => {
        addClass(e.target, variables.classNames.hidden)
        removeClass(e.target, variables.classNames.visible)

        removeClass(get(fullDescriptionButtonOpenSelector, get(e.target.closest(fullDescriptionGroupSelector))), variables.classNames.hidden)

        removeClass(get(fullDescriptionHiddenTextSelector, get(e.target.closest(fullDescriptionGroupSelector))), variables.classNames.visible)
    }

    return new Component({
        name: 'fullDescription',
        requiredTargets: [fullDescriptionGroupSelector, fullDescriptionButtonOpenSelector, fullDescriptionHiddenTextSelector],
        onInit() {
            $events.delegate
                .on('click', fullDescriptionButtonOpenSelector, handleClick)
                .on('click', fullDescriptionButtonCloseSelector, handleClickClose)
        },
        onDestroy() {
            $events.delegate
                .off('click', fullDescriptionButtonOpenSelector, handleClick)
                .off('click', fullDescriptionButtonCloseSelector, handleClickClose)
        },
    })

}